import React, { useEffect, useRef, useState } from "react";
import {
  IonModal,
  IonHeader,
  IonContent,
  IonToolbar,
  IonTitle,
  IonToggle,
} from "@ionic/react";
import { motion } from "framer-motion";

// IMG IMPORTS
import closeIcon from "../../assets/imgs/close.svg";
import discordIcon from "../../assets/imgs/discord.svg";
import settingsBackground from "../../assets/imgs/setting_bg.png";
import arrowUprightWhite from "../../assets/imgs/chevron_right.svg";
import profileIcon from "../../assets/imgs/settings-profile.png";
// import leagueSync from "../../assets/imgs/league_sync.svg";

import { useSupabaseAuth } from "../../../src/Context/AuthContext/AuthContext";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { actions } from "../../../src/Redux/store";

// WORKING IMPORTS
import SettingItem from "../Commons/SettingItem/SettingItem";
import FeedbackModal from "../FeedbackModal/FeedbackModal";

import { useRevenueCatAuth } from "../../Context/RevenueCatContext/RevenueCatContext";
import { hapticsImpactLight } from "../../lib/utils";
import { Capacitor } from "@capacitor/core";
import { useMixpanel } from "../../Context/MixpanelContext/MixpanelProvider";
import { Paragraph } from "../Commons/Paragraph";
import { Button } from "../ui/button";
interface profile {
  id?: string | undefined | null;
  user_email?: string | undefined | null;
  phone?: string | undefined | null;
  user_dob?: string | undefined | null;
  user_name?: string | undefined | null;
  avatar_url?: string | undefined | null;
  is_super_user?: boolean | undefined | null;
}

export default function SettingsModal() {
  const navigate = useNavigate(); // For navigation
  const {
    getUserProfile,
    getUserData,
    useAuthStore,
    getProfileAllowNotifications,
    setProfileAllowNotifications,
    signout,
    avatarUrl,
    setAvatarUrl,
  } = useSupabaseAuth();
  const [name, setName] = useState<string | undefined | null>();
  const [currentUser, setCurrentUser] = useState<any>(null);
  const [avatar, setAvatar] = useState<string | undefined | null>(null);
  const [allowNotifications, setAllowNotifications] = useState(false);
  const { manualRestorePurchases, isSubscribed } = useRevenueCatAuth();
  const [isLoadingRestorePurchases, setIsLoadingRestorePurchases] =
    useState(false);
  // const [advancedOutput, setAdvancedOutput] = useState(false);
  // const [tableOutputs, setTableOutputs] = useState(false);
  // const [shortenedOutputs, setShortenedOutputs] = useState(false);
  const [feedbackModal, setFeedbackModal] = useState(false); // Feedback Modal
  const platform = Capacitor.getPlatform();
  const user = useAuthStore((state: any): any => state.user);
  const Mixpanel = useMixpanel();
  const isOpen = useSelector((sate: any) => sate.modal.settingsModal?.open);
  const [fetchedNotifications, setFetchedNotifications] = useState(false);

  const fetchCurrentUser = async () => {
    const response = await getUserData();

    if (response) {
      setCurrentUser(response?.data?.user);
    }
  };

  useEffect(() => {
    // Fetch notification settings only when modal is opened and hasn't fetched before
    const fetchUserProfile = async () => {
      if (isOpen && user?.user?.id && !fetchedNotifications) {
        const profile = await getProfileAllowNotifications(
          user?.user?.id as string,
        );

        console.log(profile, "profileprofile");

        if (profile) {
          setAllowNotifications(profile.allow_notifications);
          setFetchedNotifications(true);
        }
      }
    };
    fetchUserProfile();
  }, [isOpen, user, fetchedNotifications]);

  useEffect(() => {
    if (isOpen) {
      fetchCurrentUser();
    }
  }, [isOpen]);

  const fetchProfile = async () => {
    if (
      currentUser &&
      (currentUser?.app_metadata?.provider === "phone" ||
        currentUser?.app_metadata?.provider === "apple")
    ) {
      const userProfile: profile | null | undefined = await getUserProfile(
        currentUser?.id,
      );
      setName(userProfile?.user_name);
      // Set avatar from profile data for phone/Apple users
      setAvatar(userProfile?.avatar_url);
    } else {
      const identity_data = currentUser?.identities?.[0]?.identity_data ?? null;
      setName(identity_data?.full_name);

      // For Google users, first check if they have a custom avatar in profile, otherwise use Google avatar
      const userProfile: profile | null | undefined = await getUserProfile(
        currentUser?.id,
      );
      setAvatar(userProfile?.avatar_url || identity_data?.avatar_url);
    }
  };

  useEffect(() => {
    fetchProfile();
  }, [currentUser]);

  const handleAllowNotifications = async (allowNotifications: boolean) => {
    hapticsImpactLight();
    console.log(allowNotifications, "allowNotificationsallowNotifications");
    // Update local state immediately for better user experience
    setAllowNotifications(allowNotifications);

    if (user && user?.user?.id) {
      try {
        // API call happens in the background
        const response = await setProfileAllowNotifications(
          user?.user?.id as string,
          allowNotifications,
        );
      } catch (error) {
        console.log("error updating user profile", error);
        // Revert to previous state if API call fails
        setAllowNotifications(!allowNotifications);
      }
    }
  };

  const modal = useRef<HTMLIonModalElement>(null);

  const dismiss = () => {
    Mixpanel.trackEvent("settings_closed", {
      name: "Settings modal closed",
    });
    modal.current?.dismiss();
    toggle();
  };

  const handleClose = () => {
    modal.current?.dismiss();
  };

  const toggle = () => {
    actions.modal.closeSettingsModal(null);
    setAvatarUrl(null);
    // Reset the fetch state when modal is closed
    setFetchedNotifications(false);
  };

  const openAccountModal = () => {
    Mixpanel.trackEvent("manage_account_selected", {
      name: "User clicked the account button",
    });
    actions.modal.openAccountModal(null);
  };

  // Function to handle restore purchase
  const handleRestorePurchase = async () => {
    try {
      hapticsImpactLight();
      Mixpanel.trackEvent("renew_subscription_selected", {
        name: "Renew Subscription button clicked",
      });
      setIsLoadingRestorePurchases(true);
      await manualRestorePurchases();
    } catch (error) {
      console.error("Error restoring purchases:", error);
    } finally {
      setIsLoadingRestorePurchases(false);
    }
  };

  const clickLearnMore = () => {
    navigate("/chatbot-paywall-v2");
    Mixpanel.trackEvent("tap_on_subscription_page", {
      name: "clicked the Learn More button on Setting Modal",
    });
  };

  async function signOutHandler() {
    try {
      await signout();
      window.location.replace("/welcome");
    } catch (error) {
      console.log("error on sign out", error);
    }
  }


  const navigateToPrivacyPolicy = () => {
    hapticsImpactLight();
    window.open("https://rotobot.ai/privacy-policy", "_blank", "noopener,noreferrer");
  }

  const openChatBotHistoryModal = () => {
    hapticsImpactLight();
    Mixpanel.trackEvent("chat_history_selected", {
      name: "User clicked the chat history button",
    });
    actions.modal.openChatBotHistoryModal(null);
  };
  const openFaqModal = () => {

    Mixpanel.trackEvent("faq_selected", {
      name: "FAQ Option Selected",
    });
    navigate("/FAQs");
  };
  const openFeedbackModal = () => {

    Mixpanel.trackEvent("feedback_selected", {
      name: "User clicked the feedback button",
    });
    setFeedbackModal(true);
  };


  return (
    <IonModal
      onDidDismiss={dismiss}
      className={`full-modal`}
      isOpen={isOpen}
      backdropDismiss={false}
      ref={modal}
    >
      <>
        <FeedbackModal
          setOpen={setFeedbackModal}
          open={feedbackModal}
          currentUser={currentUser}
        />
        <IonHeader class="ion-no-border modal-ion-header">
          <IonToolbar
            className="mt-[15px]"
            style={{
              "--background": "none",
            }}
          >
            <div className=" flex justify-between items-center sticky top-0 z-50 md:mx-2">
              <div onClick={handleClose} className="cursor-pointer p-2">
                <img
                  src={closeIcon}
                  alt="close"
                  className="w-[15px] h-[15px] "
                />
              </div>

              <IonTitle className="text-[20px] md:text-[22px] font-medium text-white">
                {"Settings"}
              </IonTitle>
            </div>
          </IonToolbar>
        </IonHeader>

        <IonContent
          style={{
            "--padding-bottom": "calc(var(--ion-safe-area-bottom, 0px) + 20px)",
          }}
        >
          <div className="w-full p-3" onClick={openAccountModal}>
            <div className="items-center flex cursor-pointer bg-white/10 rounded-[20px] p-[15px] transition-transform duration-300 ease-in-out hover:scale-98 active:scale-95 ">
              <img
                src={avatarUrl ? avatarUrl : avatar || profileIcon}
                alt={"profileIcon"}
                className="w-[42px] h-[42px] rounded-[12px] object-cover"
              />
              <div className="flex items-center justify-between gap-[20px] w-full h-full pl-[15px]">
                <div className="flex flex-col justify-start">
                  <span className="text-white  text-[14px] sm:text-[16px] font-normal">
                    {name || ""}
                  </span>
                  <span className="text-white/75 text-[12px] sm:text-[12px] mt-[3px] font-normal">
                    {"Manage your account"}
                  </span>
                </div>

                <div className="cursor-pointer">
                  <img src={arrowUprightWhite} alt="arrowUpright" />
                </div>
              </div>
            </div>
          </div>

          {!isSubscribed && (
            <div
              className="w-full flex items-center justify-center p-3 cursor-pointer"
              onClick={clickLearnMore}
            >
              <div className="relative flex items-center justify-center w-full max-w-[576px] mx-auto">
                <img
                  src={settingsBackground}
                  alt="Rotobot AI PRO"
                  className="w-full object-cover rounded-[10px]"
                />
                <div
                  className="absolute inset-0 p-3 text-center w-full flex flex-col justify-between rounded-[10px]"
                  style={{
                    background:
                      "linear-gradient(180deg, #000D36 -6.36%, rgba(96, 96, 96, 0) 82.02%)",
                  }}
                >
                  <div className="space-y-2 text-start">
                    <h2 className="text-2xl font-bold text-white flex gap-2 items-center">
                      rotobot ai{" "}
                      <span className="inline-flex items-center justify-center rounded-md bg-white px-2 py-1 text-sm text-[12px] text-primary font-extrabold">
                        PRO
                      </span>
                    </h2>
                    <div>
                      <p className="text-white text-[11px] font-medium">
                        Upgrade to get access to sync league.
                      </p>
                      <p className="text-white text-[11px] font-medium">
                        Get any question about your team answered.
                      </p>
                    </div>
                  </div>
                  <button className="text-[13px] font-medium bg-white text-primary hover:bg-white/90 rounded-[25px] h-[40px] mx-[16px]">
                    Learn More
                  </button>
                </div>
              </div>
            </div>
          )}

          <div className="w-full p-3 flex flex-col space-y-1">
            <SettingItem
              label="Push Notifications"
              toggle={true}
              toggleState={allowNotifications}
              action={(newState) => handleAllowNotifications(newState ?? false)}
            />
            <SettingItem label="Chat History" action={() => openChatBotHistoryModal()} />
            <SettingItem label="FAQ" action={() => openFaqModal()} />
            <SettingItem
              label="Feedback"
              action={() => openFeedbackModal()}
            />
            <SettingItem
              label="Renew Subscription"
              arrow={false}
              isLoading={isLoadingRestorePurchases}
              action={handleRestorePurchase}
            />
            <Paragraph
              text="Follow Us"
              props={{ fontSize: "15px", fontWeight: 500 }}
              ParagraphType="Pragragh22"
              color="textPrimary"
              className="pt-8 opacity-50"
            />
            <SettingItem
              icon2={discordIcon}
              label="Join Discord"
              // extLink="https://discord.gg/Kpwpu3ANss" // Commented out because action is used instead to log Mixpanel event
              action={() => {
                Mixpanel.trackEvent("follow_us_discord_selected", {
                  name: "Discord link clicked from Settings",
                });
                window.open("https://discord.gg/Kpwpu3ANss", "_blank", "noopener,noreferrer");
              }}
            />
            <SettingItem
              label="Tik Tok"
              // extLink="https://www.tiktok.com/@rotobot.ai" // Commented out because action is used instead to log Mixpanel event
              action={() => {
                Mixpanel.trackEvent("follow_us_tiktok_selected", {
                  name: "TikTok link clicked from Settings",
                });
                window.open("https://www.tiktok.com/@rotobot.ai", "_blank", "noopener,noreferrer");
              }}
            />
            <SettingItem
              label="Instagram"
              extLink="https://www.instagram.com/rotobot.ai/"
            />
            <SettingItem label="X" extLink="https://x.com/rotobot_ai" />
          </div>
          <div className=" p-3">
            <motion.div
              onClick={navigateToPrivacyPolicy}
              className="cursor-pointer"
              whileTap={{ scale: 0.95 }}
              transition={{ duration: 0.1 }}
            >
              <Paragraph
                text="Privacy Policy"
                props={{ fontSize: "15px", fontWeight: 500 }}
                ParagraphType="Pragragh22"
                color="textPrimary"
                className="pt-3 opacity-50 "
              />
            </motion.div>
            <motion.div
              onClick={navigateToPrivacyPolicy}
              className="cursor-pointer"
              whileTap={{ scale: 0.95 }}
              transition={{ duration: 0.1 }}
            >
              <Paragraph
                text="Terms of Service"
                props={{ fontSize: "15px", fontWeight: 500 }}
                ParagraphType="Pragragh22"
                color="textPrimary"
                className="pt-8 opacity-50 "
              />
            </motion.div>
            <Button
              variant="destructive"
              size="default"
              onClick={signOutHandler}
              className="bg-transparent hover:bg-transparent text-[13px] font-semibold text-[#FF0000] text-left mt-7"
            >
              {" "}
              Log Out{" "}
            </Button>
          </div>
        </IonContent>
      </>
    </IonModal>
  );
}
